<!-- 
    Standard layout displays the header and the content below it.
    The header has specific background color. The outlet wrapper forces
    white background. Angular inserts the route component immediately after
    <router-outlet></router-outlet>.
-->

<div *ngIf="!mobileQuery.matches" class="ot-layout-wrapper">
    <file360-header></file360-header>
    <main class='ot-outlet-wrapper' [@routeAnimations]="prepareRoute(outlet)">
        <router-outlet #outlet="outlet"></router-outlet>
    </main>
</div>

<!-- Side-nav (hamburger menu for mobile) -->
<mat-sidenav-container *ngIf="mobileQuery.matches" class='ot-layout-hamburger-menu-container'>
    <mat-sidenav #snav mode="over">
        <div class='ot-sidenav-container'>
            <div class='ot-sidenav-menu-title'>
                <div class='ot-sidenav-menu-title-text'>Welcome, {{userService?.currentUser?.FirstName}}</div>
            </div>
            <nav class='ot-sidenav-menu-items-container'>
                <a [routerLink]="['/home']" (click)="snav.close()" class='ot-sidenav-menu-item'>
                    <div class='ot-sidenav-menu-item-text'>Home</div>
                </a>
                <a [routerLink]="['/home/retrieve-list']" (click)="snav.close()" class='ot-sidenav-menu-item'>
                    <div class='ot-sidenav-menu-item-text'>Retrieval templates</div>
                </a>
                <a [routerLink]="['/home/index-list']" (click)="snav.close()" class='ot-sidenav-menu-item'>
                    <div class='ot-sidenav-menu-item-text'>Data entry templates</div>
                </a>
                <a [routerLink]="['/home/folder-list']" (click)="snav.close()" class='ot-sidenav-menu-item'>
                    <div class='ot-sidenav-menu-item-text'>Folders</div>
                </a>
                <div class='ot-sidenav-divider'></div>
                <a [routerLink]="['/about']" (click)="snav.close()" class='ot-sidenav-menu-item'>
                    <div class='ot-sidenav-menu-item-text'>About</div>
                </a>
                <a [href]="helpUrl" target="_blank" rel="noopener" (click)="snav.close()" class='ot-sidenav-menu-item'>
                    <div class='ot-sidenav-menu-item-text'>Help</div>
                </a>


                <button class='ot-sidenav-menu-item' (click)="logOff(); snav.close()">
                    <div class='ot-sidenav-menu-item-text'>Sign out</div>
                </button>
                <div class='ot-sidenav-flex'></div>
                <img src="assets/images/logo_file360_white28.svg" class='ot-sidenav-logo'>
            </nav>
        </div>
    </mat-sidenav>
    <mat-sidenav-content>
        <file360-header (onHamburgerOpen)="snav.open()"></file360-header>
        <main class='ot-outlet-wrapper'>
            <router-outlet></router-outlet>
        </main>
    </mat-sidenav-content>
</mat-sidenav-container>